import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { createGlobalStyle } from 'styled-components';
import { ToastProvider, ThemeProvider, GlobalStyle } from '@kinesis/bungle';
import { store } from './store';
import { router } from './routes';

const SquareStyle = createGlobalStyle`
  body, #root {
    height: 100%;
    width: 100%;
    position: fixed;
    min-width: 600px;
  }
`;

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ReduxProvider store={store}>
      <ThemeProvider>
        <ToastProvider>
          <GlobalStyle />
          <SquareStyle />
          <RouterProvider router={router} />
        </ToastProvider>
      </ThemeProvider>
    </ReduxProvider>
  </React.StrictMode>,
);
